// extracted by mini-css-extract-plugin
module.exports = {"textInput":"FileInput_textInput__NeV1V","uploadButton":"FileInput_uploadButton__2EyYA"};